import { ValueRangeBM } from 'src/types/BusinessModel/Stowage/Product/ValueRangeBM';
import { ValueRange } from 'src/types/ViewModel/Stowage/Product/ValueRange';

export const createValueRange = (valueRangeBM: ValueRangeBM): ValueRange => {
    return {
        min: valueRangeBM?.minValue?.value,
        max: valueRangeBM?.maxValue?.value,
    };
};
